var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "ContentLoader",
        {
          key: _vm.rerenderKey,
          ref: "contentLoader",
          staticClass: "container",
          attrs: {
            "profile-owner": _vm.profileOwner,
            "load-fn": _vm.loadFn,
            "card-row-options": _vm.options.cardRow
          }
        },
        [
          _vm.options.emptyState
            ? _c("ProfileVideosEmptyState", {
                attrs: { slot: "empty", options: _vm.options.emptyState },
                slot: "empty"
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }